import { Box, Grid, IconButton } from "@mui/material";
import {
  Facebook,
  Instagram,
  WhatsApp,
  Phone,
  MailOutline,
} from "@mui/icons-material";
import ImageLoader from "./ImageLoader";
import CustomText from "./CustomText";
import { useLocation, useNavigate } from "react-router-dom";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";

const Footer = ({ color }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleWhatsApp = () => {
    trackEvent("footer_whatsapp", {
      page_path: location.pathname,
      page_url: window.location.href,
      section: "footer",
      cta_name: "whatsapp_footer",
      value: 1,
    });

    openWhatsApp(
      "525959570961",
      "Hola Centro Médico MEDAM 👋. Me gustaría recibir información sobre sus servicios médicos. ¿Podrían ayudarme, por favor?",
      true,
    );
  };
  return (
    <Grid
      container
      spacing={4}
      bgcolor={color ? color : "#FFF"}
      sx={design.Back}
    >
      <Grid size={design.Grid1} />

      {/* Logo */}
      <Grid
        size={design.Grid2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <ImageLoader
            src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Negro_del_centro-medico_MEDAM.png"
            alt="Logo_Centro_Medico_Medam_Color"
            width={170}
            height={50}
          />
        </Box>
      </Grid>

      {/* Contacto */}
      <Grid size={design.Grid2}>
        <CustomText
          variant="subtitle1"
          color={color ? "#FFF" : "#000"}
          text="Contacto"
          sx={design.Title}
        >
          Contacto
        </CustomText>

        <Grid container sx={design.Align}>
          {redesSociales.map((red, index) => (
            <IconButton
              key={index}
              sx={design.IconButton}
              onClick={() => {
                if (red.type === "whatsapp") {
                  handleWhatsApp();
                } else {
                  window.open(
                    red.url,
                    red.url.startsWith("http") ? "_blank" : "_self",
                  );
                }
              }}
            >
              {red.icon}
            </IconButton>
          ))}
        </Grid>
      </Grid>

      {/* =======================
          NO BORRAR (LEGALES)
      ======================== */}

      {/* <Grid size={design.Grid2}>
        <CustomText
          variant="subtitle1"
          color={color ? "#FFF" : "#000"}
          text="Legales"
          sx={design.Title}
        >
          Legales
        </CustomText>

        <Grid container justifyContent="center">
          <ul style={design.ul}>
            {Legales.map((doc) => {
              return (
                <li key={doc.name}>
                  <CustomText
                    variant="subtitle1"
                    color={color ? "#FFF" : "#000"}
                    text={doc.name}
                    sx={design.Description}
                    onClick={() => navigate(doc.path)}
                  >
                    {doc.name}
                  </CustomText>
                </li>
              );
            })}
          </ul>
        </Grid>
      </Grid> */}

      {/* =======================
          NO BORRAR (MEDICOS)
      ======================== */}

      {/* <Grid size={design.Grid2}>
        <CustomText
          variant="subtitle1"
          color={color ? "#FFF" : "#000"}
          text="Para médicos"
          sx={design.Title}
        >
          Para médicos
        </CustomText>

        <Grid container justifyContent="center">
          <ul style={design.ul}>
            {Medicos.map((doc) => (
              <li key={doc.name}>
                <CustomText
                  variant="subtitle1"
                  color={color ? "#FFF" : "#000"}
                  text={doc.name}
                  sx={design.Description}
                  onClick={() => navigate(doc.path)}
                >
                  {doc.name}
                </CustomText>
              </li>
            ))}
          </ul>
        </Grid>
      </Grid> */}

      {/* Pacientes */}
      <Grid size={design.Grid2}>
        <CustomText
          variant="subtitle1"
          color={color ? "#FFF" : "#000"}
          text="Pacientes"
          sx={design.Title}
        >
          Pacientes
        </CustomText>

        <Grid container justifyContent="center">
          <ul style={design.ul}>
            {Pacientes.map((doc, index) => (
              <li key={index}>
                <CustomText
                  variant="subtitle1"
                  color={color ? "#FFF" : "#000"}
                  text={doc.name}
                  sx={design.Description}
                  onClick={() => navigate(doc.path)}
                >
                  {doc.name}
                </CustomText>
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>

      <Grid size={design.Grid1} />

      {/* Derechos */}
      <Grid size={12}>
        <Box sx={design.Line} />

        <CustomText
          variant="subtitle1"
          color={color ? "#FFF" : "#000"}
          text="Derechos reservados Centro Médico Medam"
          sx={design.Derechos}
        >
          © {new Date().getFullYear()} Centro Médico Medam. Todos los derechos
          reservados.
        </CustomText>
      </Grid>
    </Grid>
  );
};

export default Footer;

const design = {
  Back: {
    py: 7,
    px: {
      xs: 3,
      md: 6,
    },
    alignItems: "flex-start",
    justifyContent: "center",
  },

  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 20,
    fontWeight: 700,
    textAlign: "center",
    mb: 3,
  },

  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 16,
    lineHeight: 1.8,
    textAlign: "center",
    display: "block",
    cursor: "pointer",
    transition: ".25s",

    "&:hover": {
      color: "#1976d2",
    },
  },

  Align: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
  },

  IconButton: {
    transition: ".25s",

    "& svg": {
      fontSize: 30,
    },

    "&:hover": {
      transform: "translateY(-3px)",
    },
  },

  Derechos: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    textAlign: "center",
    mt: 3,
  },

  Line: {
    width: "100%",
    height: "1px",
    bgcolor: "rgba(0,0,0,.12)",
    mb: 3,
  },

  ul: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    textAlign: "center",
  },

  Grid1: {
    xs: 0,
    md: 1,
    lg: 1,
    xl: 1,
  },

  Grid2: {
    xs: 12,
    sm: 6,
    md: 3,
    lg: 3,
    xl: 3,
  },
};

const redesSociales = [
  {
    icon: <Instagram />,
    url: "https://www.instagram.com/centromedico_medam?igsh=ajhiYnFmenJjMXBo",
    type: "instagram",
  },
  {
    icon: <Facebook />,
    url: "https://www.facebook.com/share/19EGRopCww/?mibextid=wwXIfr",
    type: "facebook",
  },
  {
    icon: <WhatsApp />,
    url: "",
    type: "whatsapp",
  },
  {
    icon: <Phone />,
    url: "tel:+525959570961",
    type: "phone",
  },
  {
    icon: <MailOutline />,
    url: "mailto:contacto@centromedicomedam.com",
    type: "mail",
  },
];

// const Legales = [
//   { name: "Términos de uso", path: "/termsOfUse" },
//   { name: "Políticas", path: "/sitePolicies" },
//   { name: "Aviso de privacidad", path: "/comprehensivePrivacy" },
//   { name: "Permiso COFEPRIS", path: "" },
// ];

// const Medicos = [
//   { name: "Contacto", path: "/contactDoctors" },
//   { name: "Únete a Medam", path: "/joinMEDAM" },
//   { name: "Boletín mensual", path: "/newsletter" },
// ];

const Pacientes = [
  // { name: "Información al paciente", path: "/" },
  // { name: "Pre ingreso", path: "/preRegistration" },
  { name: "Nosotros", path: "/visionMission" },
  { name: "Preguntas Frecuentes", path: "/frequentlyQuestions" },
  // { name: "Boletín mensual", path: "/newsletter" },
];
